module.exports = __webpack_public_path__ + "img/home-form-car.ec60b76e.png";